import template from "./deployment-setting.html";
import controller from "./deployment-setting.controller";
import "./deployment-setting.scss";

const DeploymentSettingComponent = {
    template,
    controller,
    controllerAs: "DeploymentSetting"
};

export default DeploymentSettingComponent;


// WEBPACK FOOTER //
// ./sources/components/deployments/deployment-setting/deployment-setting.component.js